import { GeneralErrorTranslation } from '@/assets/locales/generalError/generalError.translation.en.ts';

export const generalErrorTranslation: GeneralErrorTranslation = {
  default:
    'Operacja nie powiodła się, spróbuj ponownie lub skontaktuj się z administratorem aplikacji.',
  forbidden: {
    message: 'Nie masz uprawnień dostępu do tej strony lub twoja sesja wygasła.',
    subMessage:
      'Jeśli uważasz, że powinieneś mieć uprawnienia, poproś swojego kierownika lub przełożonego o nadanie ci dostępu.',
  },
  goBack: 'Wróć',
  notAuthorized: {
    message: 'Odmowa dostępu',
    subMessage:
      'Nie masz wymaganych uprawnień do zalogowania się do systemu KnowMe. Jeśli uważasz, że to błąd lub jeśli powinieneś posiadać te uprawnienia, skontaktuj się z Orange Cyberdefense w celu uzyskania dalszej pomocy.',
  },
  notFound: {
    message: 'Strona nie istnieje!',
  },
  wentWrong: 'Ooops! Coś poszło nie tak',
};
